<div class='pagination-container'>
  <div class='pagination-left'>
    <p class='mb-0'>{{+pageSize * (page -1 )+1}}-{{ +pageSize * page}} of {{ totalData }} items
      <span class='pagination-machine-counter' *ngIf="isShowMachineCount">({{ totalMachineCount }} Total Machines) {{machineStatus ? ' (' + totalFilterMachineDataByStatus + ' ' + machineStatus + ')' : ''}}</span>
    </p>
  </div>
  <div class='pagination-right'>
    <ul>
      <li class="previous"><button class="btn btn-sm" (click)="onPreview()" [disabled]="this.page == 1">
          <i class='bi bi-chevron-left'></i></button>
      </li>
      <li class="number" *ngFor="let title of ChangeArray" [ngClass]="this.page == title ? 'active': ''"><button
          class="btn btn-sm" (click)="onPaginationClick(title)">
          {{title}}</button>
      </li>
      <li class="next"><button class="btn btn-sm" (click)="onNext()"
          [disabled]="this.pafinateArray.length == this.page">
          <i class='bi bi-chevron-right'></i></button>
      </li>
    </ul>
    <div class="form-group form-group-sm mb-0">
      <ng-select [items]="pageSizeList" bindLabel="label" bindValue="value" class="theme-ngselect"
        [(ngModel)]="pageSize" (change)="onSelectPageLangth()" [clearable]="false" [searchable]="false"></ng-select>
    </div>
  </div>
</div>